module.exports = __webpack_public_path__ + "static/zmigrod_main_8-2eaef27944c5f5e1fb05ea1e2b3b7068.png";